<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            :cellClick="chooseRow"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
<!--        <div class="btns_box" style="padding: 20px 0;">-->
<!--          <vxe-button @click="showAssignPopFunc">-->
<!--            分配-->
<!--          </vxe-button>-->
<!--        </div>-->
      </template>
    </x-grid>

<!--    &lt;!&ndash; 选择分配人 弹窗 &ndash;&gt;-->
<!--    <a-modal-->
<!--        title="选择分配人"-->
<!--        centered-->
<!--        :closable="true"-->
<!--        :footer="null"-->
<!--        :maskClosable="true"-->
<!--        v-model="showAssignPop"-->
<!--        :width="1200"-->
<!--    >-->
<!--      &lt;!&ndash;      绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数&ndash;&gt;-->
<!--      <sonDeptUsersList-->
<!--          :assignIdArr="assignIdArr"-->
<!--          :type="2"-->
<!--          v-if="showAssignPop"-->
<!--          ref="sonDeptUsersList"-->
<!--          @closeParent="closeDetailPop"-->
<!--          @openParent="openDetailPop"-->
<!--          @close="closePop"-->
<!--      >-->
<!--      </sonDeptUsersList>-->
<!--    </a-modal>-->

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridMixin} from "@/utils/GridMixin";
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
// import sonDeptUsersList from "./inheritedList";


const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错

//列
const columns = [
  // fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("custName", "客户名称", 'auto', 'center'),
  fac.makeColumn("custNatureName", "客户性质", 'auto', 'center'),
  fac.makeColumn("mobile", "联系电话", 'auto', 'center'),
  fac.makeColumn("userName", "接替人", 'auto', 'center'),
  fac.makeColumn("regionName", "接替人经销商", 'auto', 'center'),
  fac.makeColumn("dealerName", "接替人经理部", 'auto', 'center'),
  fac.makeColumn("createUserName", "分配人", 'auto', 'center'),
  fac.makeColumn("createDate", "分配时间", 'auto', 'center'),
]

const rowIdName = 'custId';

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);

//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

export default {
  mixins: [GridMixin,GridChildMixin],
  components: {
    // sonDeptUsersList
  },
  data() {
    return {
      showAssignPop:false,
      assignIdArr:[], //将选中的客户（多选）分配给分配人（单选）
      rowIdName,
      toolbarConfig,
      editRules,
      columns,
      editConfig,
      editRowId: -1,
    }
  },
  async mounted() {
  },
  methods: {
    closeDetailPop(){
      this.$emit('closeParent')
    },
    openDetailPop(){
      this.$emit('openParent')
    },
    // showAssignPopFunc() {
    //   this.refresh();
    // },
    reloadSonTable() {
      this.refresh();
    },
    // 弹出分配人列表 选择分配人进行分配
    showAssignPopFunc(row) {
      //判断操作 是批量还是单条数据
      if (!row.custId) { //批量
        let rowArr = this.getRows();
        if (!rowArr.length) {
          this.$message.error('请选择一条数据');
          return false;
        } else {
          let rowResult = this.$refs['grid'].$refs['xGrid'].getCheckboxRecords();
          this.assignIdArr = rowResult.map(item => item.custId);
          this.showAssignPop = true;
        }
      } else {  //单条数据
        this.assignIdArr.push(row.custId);
        this.showAssignPop = true;
      }
    },
    // 关闭弹窗
    closePop() {
      this.showAssignPop = false; //分配人列表
      this.refresh();
    },
  }
}
</script>

<style scoped>
/*/deep/ .vxe-table--render-wrapper {*/
/*  margin-top: 30px;*/
/*}*/
</style>